/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/UpdateStatus.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_STATUS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateStatusMethods extends IPluginMethodMap {
  getUpdateStatus(args: any): Promise<any>;
}

export interface UpdateStatusProps {
  id: string;
}

export class UpdateStatusService implements IAgentPlugin {
  readonly methods: IUpdateStatusMethods;

  constructor() {
    this.methods = {
      getUpdateStatus: this.getUpdateStatus.bind(this),
    };
  }

  async getUpdateStatus(args: UpdateStatusProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_STATUS,
          variables: {
            input:{
              ...args,
            }
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.updateCycloneStatus?.status) {
          return {
            notification: notification?.updateStatus,
          };
        }
      }
    } catch (err: any) {
      // console.log("error in revoke credential", err?.message);
      throw err;
    }
  }
}
